import * as React from 'react';
import { connect } from 'react-redux';

import { Publications, IPublicationsProps } from '../../components/Publications';
import { prepareContent } from './utils/prepareContent';
import { selectPublication } from './utils/selectPublication';
import { IApplicationState } from '../../types/redux';
import { IArticlePreviewSchema } from '../../repositories/valuation-b2b/entities/articles_list/ArticlePreviewSchema';
import { getPublication } from '../../actions/publications';
import { ISelectedPublication } from '../../components/Publications/types';

interface IStoreProps {
  content: IArticlePreviewSchema[] | null;
  selectPublication(articleId: number): ISelectedPublication;
}

type TDispatchProps = Pick<IPublicationsProps, 'getPublication'>;

export const _PublicationsContainer: React.FC<IStoreProps & TDispatchProps> = props => {
  if (!props.content) {
    return null;
  }

  const content = prepareContent(props.content);

  return (
    <Publications content={content} getPublication={props.getPublication} selectPublication={props.selectPublication} />
  );
};

export const mapStateToProps = (state: IApplicationState): IStoreProps => {
  return {
    content: state.publications.data,
    selectPublication: articleId => selectPublication(articleId, state),
  };
};

export const mapDispatchToProps: TDispatchProps = {
  getPublication,
};

export const PublicationsContainer = connect(mapStateToProps, mapDispatchToProps)(_PublicationsContainer);
